import { api } from './apiClient';

const ENDPOINT = '/api/v1/admin/dashboard-festival-banner';

const toError = (error) => {
  if (error.response) {
    const errorData = error.response.data;
    if (Array.isArray(errorData?.errors)) {
      return new Error(errorData.errors.join(', '));
    }
    return new Error(errorData?.message || `Server error: ${error.response.status}`);
  }
  if (error.request) {
    return new Error('Unable to reach the server. Please check your internet connection or try again later.');
  }
  return new Error(error.message || 'An unexpected error occurred');
};

/**
 * GET the singleton festival banner.
 * Returns null when no banner exists (404).
 */
export const getDashboardFestivalBanner = async () => {
  try {
    const response = await api.get(ENDPOINT);
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    throw toError(error);
  }
};

/** POST upsert — create or overwrite the single banner */
export const upsertDashboardFestivalBanner = async (payload) => {
  try {
    const response = await api.post(ENDPOINT, payload);
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

/** PUT partial update (requires dashboard_festival_banner_id + at least one field) */
export const updateDashboardFestivalBanner = async (payload) => {
  try {
    const response = await api.put(ENDPOINT, payload);
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

export const deleteDashboardFestivalBanner = async (id) => {
  try {
    const response = await api.delete(`${ENDPOINT}/${id}`);
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};
